import { api } from 'redux/api/index.api';
import Analytics from 'utils/Analytics';

export const phasesApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchPhases: builder.query({
      query: ({ idData, lang, limit, withoutDisabled = true }) => ({
        url: `projects/${idData}/phases`,
        method: 'GET',
        headers: { 'Accept-Language': lang },
        params: {
          without_disabled: withoutDisabled,
          limit,
        },
      }),
      transformResponse: response =>
        response.phases?.map(phase => ({ ...phase, __reorder__: phase.name })),
      providesTags: ['Phase'],
    }),
    createPhases: builder.mutation({
      query: ({ idData, phases }) => ({
        url: `projects/${idData}/phases/create-bulk`,
        method: 'POST',
        body: { phases },
      }),
      transformResponse: () => {
        Analytics.track('phases_phase_creation_succeeded');
      },
      transformErrorResponse: () => {
        Analytics.track('phases_phase_creation_failed');
      },
      invalidatesTags: ['Phase'],
    }),
    updatePhase: builder.mutation({
      query: ({ idData, modifiedItem }) => ({
        url: `projects/${idData}/phases/${modifiedItem?.id}`,
        method: 'PUT',
        body: modifiedItem,
      }),
      transformResponse: () => {
        Analytics.track('phases_phase_update_succeeded');
      },
      transformErrorResponse: () => {
        Analytics.track('phases_phase_update_failed');
      },
      invalidatesTags: ['Phase'],
    }),
    renamePhase: builder.mutation({
      query: ({ idData, phase, name, lang }) => ({
        url: `projects/${idData}/phases/${phase?.id}`,
        method: 'PUT',
        headers: { 'Accept-Language': lang },
        body: JSON.stringify({
          ...phase,
          name,
        }),
      }),
      transformResponse: () => {
        Analytics.track('phases_phase_update_succeeded');
      },
      transformErrorResponse: () => {
        Analytics.track('phases_phase_update_failed');
      },
      invalidatesTags: ['Phase'],
    }),
    deletePhase: builder.mutation({
      query: ({ idData, id }) => ({
        url: `projects/${idData}/phases/${id}`,
        method: 'DELETE',
      }),
      transformResponse: () => {
        Analytics.track('phases_phase_deletion_succeeded');
      },
      transformErrorResponse: () => {
        Analytics.track('phases_phase_deletion_failed');
      },
      invalidatesTags: ['Phase'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchPhasesQuery,
  useCreatePhasesMutation,
  useUpdatePhaseMutation,
  useRenamePhaseMutation,
  useDeletePhaseMutation,
} = phasesApi;
